import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmt = (k, v) => (["created_at", "expires_at"].includes(k) && v ? new Date(v).toLocaleString() : v);

export const ListTab = ({ path, cols, testId }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(path).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, [path]);
  return (
    <div data-testid={`admin-list-${testId}`} className="border border-white/10 overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400 border-b border-white/10">
          <tr>{cols.map(([k, l]) => <th key={k} className="text-left p-4">{l}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-b border-white/5 align-top">
              {cols.map(([k]) => <td key={k} className="p-4 text-zinc-200 max-w-md whitespace-pre-wrap">{fmt(k, r[k])}</td>)}
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={cols.length} className="p-8 text-zinc-400 font-mono text-xs uppercase tracking-[0.2em]">Nothing yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
